import { ref, Ref } from "vue";
import { useRouter } from "vue-router";

export interface AutoOpenSearchApi {
  shouldAutoOpenSearch: Ref<boolean>;
  enableAutoOpenSearch: () => void;
  disableAutoOpenSearch: () => void;
}

export const key = Symbol("autoOpenSearch");

export default function createData(): AutoOpenSearchApi {
  const router = useRouter();
  const shouldAutoOpenSearch = ref(false);

  function enableAutoOpenSearch() {
    shouldAutoOpenSearch.value = true;
  }

  function disableAutoOpenSearch() {
    shouldAutoOpenSearch.value = false;

    if (router.currentRoute.value.query.fromSearch) {
      router.push({
        query: {
          backButton: "true",
        },
      });
    }
  }

  return {
    shouldAutoOpenSearch,
    enableAutoOpenSearch,
    disableAutoOpenSearch,
  };
}

export const defaultApi = {
  shouldAutoOpenSearch: ref(false),
  enableAutoOpenSearch: () => {},
  disableAutoOpenSearch: () => {},
};

export const storybookApi = {
  shouldAutoOpenSearch: ref(false),
  enableAutoOpenSearch: () => {},
  disableAutoOpenSearch: () => {},
};
